module.exports = __webpack_public_path__ + "static/media/news-image-01.664d079f.jpg";